<div class="silence"><slot>silence</slot></div>
